import {
  MessagingMethodsDTO,
  MessagingMethodsParams,
} from './messagingMethodsTypes'

import { apiCatalogs, endpoints } from '@/api'

async function fetchMessagingMethods(
  params: MessagingMethodsParams,
): Promise<{ methods: MessagingMethodsDTO[] }> {
  const response = await apiCatalogs.get<{ methods: MessagingMethodsDTO[] }>(
    endpoints.catalogs.messagingMethods.getMessagingMethods,
    {
      params: { ...params },
    },
  )

  return response.data
}

export const messagingMethodsApi = {
  fetchMessagingMethods,
}
